import React, { useState, useEffect, useRef } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";
import { formatMoneda, validaSoloNumero } from "../../util/varios";
import moment from "moment";
import CatalogoCliente from "../../catalogos/catalogoCliente";
import CatalogoPersona from "../../catalogos/catalogoPersona";

const TablaBeneficiario = () => {
  var op = require("../../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");
  let anio = JSON.parse(sessionStorage.getItem("anioactu"));
  let registrado = false;
  let muni = "";
  let ciu = "";
  let valrif = 0;

  const accbtnbeneficiarios = JSON.parse(
    sessionStorage.getItem("accbtnbeneficiariosc")
  );
  const fechaTope = moment(JSON.parse(sessionStorage.getItem("fechasistema")))
    .format("YYYY-MM-DD")
    .replace(anio.toString(), (anio - 18).toString());

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const chkNatural = useRef();
  const chkJuridico = useRef();
  const txtId = useRef();
  const cmbRif = useRef();
  const txtRif = useRef();
  const txtRazon = useRef();
  const txtDirClient = useRef();
  const txtEmailClient = useRef();
  const txtTlf1Client = useRef();
  const txtTlf2Client = useRef();
  const txtEstado = useRef();
  const txtMunicipio = useRef();
  const txtCiudad = useRef();
  const txtRetencion = useRef();
  const cmbNacionalidad = useRef();
  const txtCedRes = useRef();
  const cmbSexo = useRef();
  const txtFechaNac = useRef();
  const txtNomResp = useRef();
  const txtApeResp = useRef();
  const txtDireccion = useRef();
  const txtEmail = useRef();
  const txtTlf1 = useRef();
  const txtTlf2 = useRef();

  const [body, setBody] = useState(null);
  const [habilitado, setHabilitado] = useState(true);
  const [tituloHeader, setTituloHeader] = useState("Gestionar Beneficiario.");
  const [catalogoPersona, setCatalogoPersona] = useState(false);
  const [catalogoCliente, setCatalogoCliente] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [visibleBtn, setVisibleBtn] = useState("visible");

  const [titleCed, setTitleCed] = useState("CEDULA:");
  const [cmbCedula, setCmbCedula] = useState([{ value: "V" }, { value: "E" }]);
  const [estados, setEstados] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [ciudades, setCiudades] = useState([]);
  const [habilitadoNU, setHabilitadoNU] = useState(true);
  const [operacionPer, setOperacionPer] = useState(0);
  const [operacion, setOperacion] = useState(0);
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoper: true,
  });

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const datosRes = () => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";
    let nomid2 = "nacionalidad";
    let id = txtCedRes.current.value;
    let id2 = cmbNacionalidad.current.value;
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${id2}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          cmbSexo.current.value = "";
          txtFechaNac.current.value = "";
          txtNomResp.current.value = "";
          txtApeResp.current.value = "";
          txtDireccion.current.value = "";
          txtEmail.current.value = "";
          txtTlf1.current.value = "";
          txtTlf2.current.value = "";

          if (response.data !== "") {
            setHabilitadoNU(true);
            setOperacionPer(0);
            cmbSexo.current.value = response.data.sexo;
            txtFechaNac.current.value = moment(
              response.data.fnacimiento
            ).format("YYYY-MM-DD");
            txtNomResp.current.value = response.data.nombres;
            txtApeResp.current.value = response.data.apellidos;
            txtDireccion.current.value = response.data.direccion;
            txtEmail.current.value = response.data.correoe;
            txtTlf1.current.value = response.data.tlf1;
            txtTlf2.current.value = response.data.tlf2;
            if (!botones.consultar) {
              btnCancela.current.focus();
            } else {
              btnAcepta.current.focus();
            }
          } else {
            txtNomResp.current.focus();
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto:
                "No existe una persona con este N° de cedula porfavor registre sus datos",
              icono: "informacion",
            });
            setOperacionPer(1);
            setHabilitadoNU(false);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "estado";
    let orden = "idestado";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setEstados(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const selectMunicipios = (id) => {
    let campos = "*";
    let nomtab = "municipio";
    let nomid = "idestado";
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMunicipios(response.data);
          if (
            registrado ||
            !botones.consultar ||
            !botones.modificar ||
            !botones.eliminar
          ) {
            txtMunicipio.current.value = muni;
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectCiudad = (id) => {
    let campos = "*";
    let nomtab = "ciudad";
    let nomid = "idmunicipio";
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setCiudades(response.data);
          if (
            registrado ||
            !botones.consultar ||
            !botones.modificar ||
            !botones.eliminar
          ) {
            txtCiudad.current.value = ciu;
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    setOperacion(0);
    setTituloHeader("Gestionar Beneficiario.");
    setActivate(false);
    setBody(null);
    setOperacionPer(0);
    setHabilitado(true);
    setHabilitadoNU(true);
    setMunicipios([]);
    setCiudades([]);
    setTitleCed("CEDULA:");
    setCmbCedula([{ value: "V" }, { value: "E" }]);
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      catalogoper: true,
    });
    txtRetencion.current.checked = false;
    chkNatural.current.checked = true;
    cmbRif.current.value = "";
    txtRif.current.value = "";
    txtId.current.value = 0;
    txtRazon.current.value = "";
    txtDirClient.current.value = "";
    txtTlf1Client.current.value = "";
    txtTlf2Client.current.value = "";
    txtEmailClient.current.value = "";
    txtEstado.current.value = "";
    txtMunicipio.current.value = "";
    txtCiudad.current.value = "";

    cmbRif.current.setAttribute("disabled", "disabled");
    txtRif.current.setAttribute("disabled", "disabled");
    chkNatural.current.setAttribute("disabled", "disabled");
    chkJuridico.current.setAttribute("disabled", "disabled");

    cmbNacionalidad.current.value = "";
    txtCedRes.current.value = "";
    cmbSexo.current.value = "";
    txtFechaNac.current.value = "";
    txtNomResp.current.value = "";
    txtApeResp.current.value = "";
    txtDireccion.current.value = "";
    txtEmail.current.value = "";
    txtTlf1.current.value = "";
    txtTlf2.current.value = "";
    setVisibleBtn("visible");
  };

  const onChangeValidar = () => {
    let sigue = true;
    if (!botones.incluir || !botones.modificar) {
      if (txtCedRes.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar la cedula el responsable",
          icono: "informacion",
        });
        txtCedRes.current.focus();
        sigue = false;
      } else if (operacionPer === 1) {
        if (cmbNacionalidad.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe seleccionar la nacionalidad del responsable",
            icono: "informacion",
          });
          cmbNacionalidad.current.focus();
          sigue = false;
        } else if (cmbSexo.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe seleccionar el Sexo del responsable",
            icono: "informacion",
          });
          cmbSexo.current.focus();
          sigue = false;
        } else if (txtFechaNac.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar fecha nacimiento del responsable",
            icono: "informacion",
          });
          txtFechaNac.current.focus();
          sigue = false;
        } else if (txtNomResp.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el nombre del responsable",
            icono: "informacion",
          });
          txtNomResp.current.focus();
          sigue = false;
        } else if (txtApeResp.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el apellido del responsable",
            icono: "informacion",
          });
          txtApeResp.current.focus();
          sigue = false;
        } else if (txtDireccion.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar la dirección del responsable",
            icono: "informacion",
          });
          txtDireccion.current.focus();
          sigue = false;
        } else if (txtEmail.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el correo del responsable",
            icono: "informacion",
          });
          txtEmail.current.focus();
          sigue = false;
        } else if (txtTlf1.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el Telefono del responsable",
            icono: "informacion",
          });
          txtTlf1.current.focus();
          sigue = false;
        } else if (txtTlf2.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el Celular del responsable",
            icono: "informacion",
          });
          txtTlf2.current.focus();
          sigue = false;
        }
      }
    }

    if (sigue) {
      var cliente = [];
      var repre = [];
      cliente.push({
        idagente: txtId.current.value,
        nombre: txtRazon.current.value.toUpperCase().trim(),
        direccion: txtDirClient.current.value.toUpperCase().trim(),
        tipoper: chkNatural.current.checked ? 0 : 1,
        rif: cmbRif.current.value + txtRif.current.value,
        reprelegal: cmbNacionalidad.current.value + txtCedRes.current.value,
        telefono: txtTlf1Client.current.value,
        celular: txtTlf2Client.current.value,
        email: txtEmailClient.current.value.toUpperCase().trim(),
        agenteretencion: txtRetencion.current.checked ? true : false,
        beneficiario: true,
        estado: txtEstado.current.value.trim(),
        municipio: txtMunicipio.current.value.trim(),
        ciudad: txtCiudad.current.value.trim(),
      });
      repre.push({
        cedula: parseInt(txtCedRes.current.value),
        correoe: txtEmail.current.value.toUpperCase().trim(),
        tlf1: txtTlf1.current.value.trim(),
        tlf2: txtTlf2.current.value.trim(),
        apellidos: txtApeResp.current.value.toUpperCase().trim(),
        direccion: txtDireccion.current.value.toUpperCase().trim(),
        fnacimiento: txtFechaNac.current.value.trim(),
        nacionalidad: cmbNacionalidad.current.value.trim(),
        nombres: txtNomResp.current.value.toUpperCase().trim(),
        sexo: cmbSexo.current.value.trim(),
      });

      setBody({
        operacionper: operacionPer,
        agente: cliente,
        repre: repre,
        client: [],
      });

      let msg = "";
      if (!botones.incluir) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (!botones.modificar) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (!botones.eliminar) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const procesarRegistro = () => {
    setActivate(true);
    let ope = 0;
    if (!botones.incluir) {
      ope = 1;
    } else if (!botones.modificar) {
      ope = 2;
    } else if (!botones.eliminar) {
      ope = 3;
    }
    let endpoint = `${op.conexion}/api/agente/actualizar/${ope}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (ope === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (ope === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (ope === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "agente_rif_key"'
          ) {
            mensaje = "Ya existe un Registro con este rif";
          } else if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "agente_email_key"'
          ) {
            mensaje = "Ya existe un Registro con este correo";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const seleccionarRegistro = (rif) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "rif";
    let nomid2 = "beneficiario";
    let id = rif;
    let endpoint = "";

    if (!botones.incluir) {
      endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
    } else {
      endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;
    }

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            if (
              botones.incluir === false &&
              response.data.beneficiario &&
              response.data.rif === valrif
            ) {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto:
                  "¡El Beneficiario con el N° de Cédula o RIF" +
                  " " +
                  response.data.rif +
                  " " +
                  "ya Existe!",
                icono: "informacion",
              });
              txtId.current.value = "";
              txtRazon.current.value = "";
              txtDirClient.current.value = "";
              cmbNacionalidad.current.value = "";
              txtCedRes.current.value = "";
              txtTlf1Client.current.value = "";
              txtTlf2Client.current.value = "";
              txtEmailClient.current.value = "";
              txtEstado.current.value = "";
              txtMunicipio.current.value = "";
              txtCiudad.current.value = "";
              txtCedRes.current.value = "";
              cmbSexo.current.value = "";
              txtFechaNac.current.value = "";
              txtNomResp.current.value = "";
              txtApeResp.current.value = "";
              txtDireccion.current.value = "";
              txtEmail.current.value = "";
              txtTlf1.current.value = "";
              txtTlf2.current.value = "";
              txtRif.current.value = "";
              cmbRif.current.value = "";
              txtRetencion.current.checked = false;
            } else {
              setOperacionPer(0);

              if (!botones.incluir) {
                registrado = true;
              } else {
                registrado = false;
              }

              txtId.current.value = response.data.idagente;
              txtRazon.current.value = response.data.nombre.trim();
              txtDirClient.current.value = response.data.direccion.trim();
              chkNatural.current.checked =
                response.data.tipoper === 0 ? true : false;
              cmbRif.current.value = response.data.rif.trim().substring(0, 1);
              txtRif.current.value = response.data.rif.trim().substring(1, 10);
              txtTlf1Client.current.value = response.data.telefono;
              txtTlf2Client.current.value = response.data.celular;
              txtEmailClient.current.value = response.data.email.trim();
              txtEstado.current.value = response.data.estado.trim();
              txtRetencion.current.checked = response.data.agenteretencion
                ? true
                : false;
              cmbNacionalidad.current.value = response.data.reprelegal
                .trim()
                .substring(0, 1);
              txtCedRes.current.value = response.data.reprelegal
                .trim()
                .substring(1, 9);

              muni = response.data.municipio.trim();
              ciu = response.data.ciudad.trim();

              selectMunicipios(response.data.estado.trim());
              selectCiudad(response.data.municipio.trim());
              datosRes();

              if (!botones.modificar) {
                setBotones({ ...botones, catalogoper: false });
              }
            }
          } else {
            if (botones.consultar === false) {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto:
                  "¡El Beneficiario con el N° de Cédula o RIF" +
                  " " +
                  txtRif.current.value +
                  " " +
                  "No Existe!",
                icono: "error",
              });
              txtRazon.current.focus();
            }

            txtRazon.current.focus();
            txtId.current.value = 0;
            txtRazon.current.value = "";
            txtDirClient.current.value = "";
            cmbNacionalidad.current.value = "";
            txtCedRes.current.value = "";
            txtTlf1Client.current.value = "";
            txtTlf2Client.current.value = "";
            txtEmailClient.current.value = "";
            txtEstado.current.value = "";
            txtMunicipio.current.value = "";
            txtCiudad.current.value = "";
            txtCedRes.current.value = "";
            cmbSexo.current.value = "";
            txtRetencion.current.checked = false;
            txtFechaNac.current.value = "";
            txtNomResp.current.value = "";
            txtApeResp.current.value = "";
            txtDireccion.current.value = "";
            txtEmail.current.value = "";
            txtTlf1.current.value = "";
            txtTlf2.current.value = "";
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarCliente = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (cmbRif.current.value !== "" && event.target.value !== "") {
        let rif = cmbRif.current.value + event.target.value;
        seleccionarRegistro(rif);
      }
    }
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (cmbNacionalidad.current.value !== "") {
          datosRes();
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "debe seleccionar la nacionalidad",
            icono: "informacion",
          });
          cmbNacionalidad.current.focus();
        }
      } else {
        cmbNacionalidad.current.value = "";
        cmbSexo.current.value = "";
        txtFechaNac.current.value = "";
        txtNomResp.current.value = "";
        txtApeResp.current.value = "";
        txtDireccion.current.value = "";
        txtEmail.current.value = "";
        txtTlf1.current.value = "";
        txtTlf2.current.value = "";
        setHabilitadoNU(true);
      }
    }
  };

  const onChangeCliente = (e) => {
    if (e.target.name === "estado") {
      setMunicipios([]);
      setCiudades([]);
      if (e.target.value !== "") {
        selectMunicipios(e.target.value);
      }
    } else if (e.target.name === "municipio") {
      setCiudades([]);
      if (e.target.value !== "") {
        selectCiudad(e.target.value);
      }
    } else if (e.target.name === "tipoper") {
      if (parseInt(e.target.value) === 0) {
        chkNatural.current.checked = true;
        setTitleCed("CEDULA:");
        setCmbCedula([{ value: "V" }, { value: "E" }]);
      } else {
        chkJuridico.current.checked = true;
        setTitleCed("R.I.F:");
        setCmbCedula([
          { value: "J" },
          { value: "V" },
          { value: "G" },
          { value: "P" },
        ]);
      }
    }
  };

  const onChange = (e) => {
    let n;
    let r;

    if (
      e.target.name === "correoe" ||
      e.target.name === "apellidos" ||
      e.target.name === "direccion" ||
      e.target.name === "nombres" ||
      e.target.name === "descripcion"
    ) {
      e.target.value = e.target.value;
    } else if (
      e.target.name === "nacionalidad" &&
      txtCedRes.current.value !== ""
    ) {
      if (e.target.value !== "") {
        datosRes();
      } else {
        txtCedRes.current.value = "";
        cmbSexo.current.value = "";
        txtFechaNac.current.value = "";
        txtNomResp.current.value = "";
        txtApeResp.current.value = "";
        txtDireccion.current.value = "";
        txtEmail.current.value = "";
        txtTlf1.current.value = "";
        txtTlf2.current.value = "";
        setHabilitadoNU(true);
      }
    } else if (e.target.name === "cedula") {
      n = cmbRif.current.value;
      r = txtRif.current.value;
    }
    valrif = n + r;
  };

  const onCatalogoCliente = (values) => {
    setCatalogoCliente(false);

    if (parseInt(values.tipoper) === 0) {
      chkNatural.current.checked = true;
      setTitleCed("CEDULA:");
      setCmbCedula([{ value: "V" }, { value: "E" }]);
    } else {
      chkJuridico.current.checked = true;
      setTitleCed("R.I.F:");
      setCmbCedula([
        { value: "J" },
        { value: "V" },
        { value: "G" },
        { value: "P" },
      ]);
    }

    txtRazon.current.value = values.nombre;

    seleccionarRegistro(values.rif.trim());
    //datosRes();
    if (!botones.modificar) {
      setBotones({ ...botones, catalogoper: false });
    }
  };

  const onCatalogoPersona = (values) => {
    setCatalogoPersona(false);
    setHabilitadoNU(true);
    setOperacionPer(0);
    cmbNacionalidad.current.value = values.nacPer;
    txtCedRes.current.value = values.cedPer;
    cmbSexo.current.value = values.sexoPer;
    txtFechaNac.current.value = moment(values.fnacPer).format("YYYY-MM-DD");
    txtNomResp.current.value = values.nomPer;
    txtApeResp.current.value = values.apePer;
    txtDireccion.current.value = values.direPer;
    txtEmail.current.value = values.correoPer;
    txtTlf1.current.value = values.tlf1Per;
    txtTlf2.current.value = values.tlf2Per;
  };

  const onBotones = (op) => (e) => {
    setOperacion(op);
    e.preventDefault();

    if (op === 1) {
      if (
        accbtnbeneficiarios &&
        accbtnbeneficiarios.toString().substring(0, 1) === "1"
      ) {
        setVisibleBtn("hidden");
        setTituloHeader("Incluir Beneficiario.");
        setHabilitado(false);
        setBotones({
          incluir: false,
          consultar: true,
          modificar: true,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: true,
          catalogoper: false,
        });
        cmbRif.current.removeAttribute("disabled");
        txtRif.current.removeAttribute("disabled");
        chkNatural.current.removeAttribute("disabled");
        chkJuridico.current.removeAttribute("disabled");
        txtRif.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 2) {
      if (
        accbtnbeneficiarios &&
        accbtnbeneficiarios.toString().substring(1, 2) === "1"
      ) {
        setTituloHeader("Editar Beneficiario.");
        setVisibleBtn("hidden");
        setHabilitado(false);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: false,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
        cmbRif.current.removeAttribute("disabled");
        txtRif.current.removeAttribute("disabled");
        chkNatural.current.removeAttribute("disabled");
        chkJuridico.current.removeAttribute("disabled");
        txtRif.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 3) {
      if (
        accbtnbeneficiarios &&
        accbtnbeneficiarios.toString().substring(3, 4) === "1"
      ) {
        setTituloHeader("Eliminar Beneficiario.");
        setVisibleBtn("hidden");
        setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: true,
          eliminar: false,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
        cmbRif.current.removeAttribute("disabled");
        txtRif.current.removeAttribute("disabled");
        chkNatural.current.removeAttribute("disabled");
        chkJuridico.current.removeAttribute("disabled");
        txtRif.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 4) {
      if (
        accbtnbeneficiarios &&
        accbtnbeneficiarios.toString().substring(2, 3) === "1"
      ) {
        setTituloHeader("Consultar Beneficiario.");
        setVisibleBtn("hidden");
        setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: false,
          modificar: true,
          eliminar: true,
          aceptar: true,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
        cmbRif.current.removeAttribute("disabled");
        txtRif.current.removeAttribute("disabled");
        chkNatural.current.removeAttribute("disabled");
        chkJuridico.current.removeAttribute("disabled");
        txtRif.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      setVisibleBtn("visible");
      blanquear();
    }
  };

  useEffect(() => {
    seleccionarRegistros();
  }, []);

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12 py-2" style={{ margin: 0 }}>
        <div className="row col-md-12 py-2 m-0">
          <div className="col-md-8 py-2 mx-auto card shadow ">
            <div className="col-md-12 row mx-auto  rounded py-2">
              <div className="col-md-12 ">
                <div className="col-md-12 border-azul rounded py-2 row mx-auto mb-2 azulGradiant shadow text-light justify-content-between">
                  <div className="col-md-4">
                    <h3>{tituloHeader}</h3>
                  </div>
                  <div className="col-md-3 d-flex justify-content-end">
                    <a href="/inicio" className="text-light ">
                      <i className="fas fa-times mx-2"></i>
                      <span className="fw-bold">Salir</span>
                    </a>
                  </div>
                </div>
                <fieldset
                  className=" row col-sm-12 mx-auto border-azul rounded"
                  style={{ fontSizeAdjust: "0.6" }}
                >
                  <legend
                    className="float-none w-auto fw-bold"
                    style={{ fontSize: "15px" }}
                  >
                    Datos de Beneficiario
                  </legend>
                  <input
                    ref={txtId}
                    autoComplete="off"
                    type="hidden"
                    className="form-control"
                    name="idagente"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                  <div className="input-group input-group-sm mb-2 col-pd-270 px-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      {titleCed}{" "}
                    </label>
                    <select
                      ref={cmbRif}
                      name="cmbrif"
                      disabled
                      className="form-select form-select-sm col-md-3 text-center "
                      aria-label=".form-select-sm example"
                      onChange={onChange}
                    >
                      <option value="">--</option>
                      {cmbCedula &&
                        cmbCedula.map((item, index) => (
                          <option key={index} value={item.value}>
                            {" "}
                            {item.value}{" "}
                          </option>
                        ))}
                    </select>
                    <input
                      ref={txtRif}
                      autoComplete="off"
                      maxLength={9}
                      type="text"
                      disabled
                      className="form-control fs-6"
                      name="cedula"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      onKeyUp={validarCliente}
                      onChange={onChange}
                    />
                    <button
                      disabled={botones.catalogo}
                      type="button"
                      onClick={() => setCatalogoCliente(true)}
                      className="btn btn-success"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>

                  <div className="col"></div>
                  <div className="col-xl-5 col-lg-7 col-md-12 row">
                    <label className="col-md-5">TIPO PERSONA: </label>
                    <div className="col">
                      <div className="form-check">
                        <input
                          className="form-check-input my-auto fs-6"
                          disabled
                          type="radio"
                          name="tipoper"
                          value={0}
                          ref={chkNatural}
                          defaultChecked
                          id="tipoper"
                          onChange={onChangeCliente}
                        />
                        <label className="form-check-label" htmlFor="tipoper">
                          {" "}
                          Natural{" "}
                        </label>
                      </div>
                    </div>
                    <div className="col">
                      <div className="form-check">
                        <input
                          className="form-check-input my-auto fs-6"
                          disabled
                          type="radio"
                          name="tipoper"
                          value={1}
                          ref={chkJuridico}
                          id="tipoper"
                          onChange={onChangeCliente}
                        />
                        <label className="form-check-label" htmlFor="tipoper">
                          {" "}
                          Juridica{" "}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="input-group input-group-sm mb-2 col-xl-12 col-lg-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      {titleCed === "CEDULA:"
                        ? "NOMBRES Y APELLIDOS"
                        : "NOMBRE/RAZON SOCIAL"}
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      ref={txtRazon}
                      disabled={habilitado}
                      name="nombres"
                      className="form-control text-uppercase fs-6"
                      onChange={onChange}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>

                  <div className="input-group input-group-sm mb-2 col-xl-12 col-lg-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      DIRECCION:
                    </label>
                    <textarea
                      type="area"
                      autoComplete="off"
                      ref={txtDirClient}
                      disabled={habilitado}
                      name="direccion"
                      className="form-control text-uppercase fs-6"
                      onChange={onChange}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      style={{ height: 40 }}
                    />
                  </div>

                  <div className="input-group input-group-sm mb-2 col-pd-230 px-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      ESTADO:
                    </label>
                    <select
                      ref={txtEstado}
                      disabled={habilitado}
                      onChange={onChangeCliente}
                      name="estado"
                      idciudad="estado"
                      className="form-select form-select-sm text-uppercase"
                      aria-label=".form-select-sm example"
                    >
                      <option value="">seleccione</option>
                      {estados &&
                        estados.map((item, index) => (
                          <option key={index} value={item.idestado}>
                            {item.nombre}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="input-group input-group-sm mb-2 col-pd-340 px-1">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      MUNICIPIO:
                    </label>
                    <select
                      ref={txtMunicipio}
                      disabled={habilitado}
                      onChange={onChangeCliente}
                      name="municipio"
                      id="municipio"
                      className="form-select form-select-sm text-uppercase"
                      aria-label=".form-select-sm example"
                    >
                      <option value="">seleccione</option>
                      {municipios &&
                        municipios.map((item, index) => (
                          <option key={index} value={item.idmunicipio}>
                            {item.nombre}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="input-group input-group-sm mb-2 col-5 px-1">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CIUDAD:
                    </label>
                    <select
                      ref={txtCiudad}
                      disabled={habilitado}
                      name="ciudad"
                      id="ciudad"
                      className="form-select form-select-sm text-uppercase"
                      aria-label=".form-select-sm example"
                    >
                      <option value="">seleccione</option>
                      {ciudades &&
                        ciudades.map((item, index) => (
                          <option key={index} value={item.idciudad}>
                            {item.nombre}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="input-group input-group-sm mb-2 col-xl-4 col-lg-4 col-md-6 col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      EMAIL:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      ref={txtEmailClient}
                      disabled={habilitado}
                      className="form-control text-uppercase fs-6"
                      name="correoe"
                      aria-label="Sizing example input"
                      onChange={onChange}
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-pd-220 px-1">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      TELEFONO:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      maxLength={11}
                      ref={txtTlf1Client}
                      disabled={habilitado}
                      className="form-control fs-6"
                      name="tlf1"
                      aria-label="Sizing example input"
                      onChange={onChange}
                      aria-describedby="inputGroup-sizing-sm"
                      onKeyUp={handleInputNumChange}
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-pd-210 px-1">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CELULAR:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      maxLength={11}
                      ref={txtTlf2Client}
                      disabled={habilitado}
                      className="form-control fs-6"
                      name="tlf2"
                      aria-label="Sizing example input"
                      onChange={onChange}
                      aria-describedby="inputGroup-sizing-sm"
                      onKeyUp={handleInputNumChange}
                    />
                  </div>

                  <div className="col-pd-210">
                    <div className="form-check">
                      <input
                        ref={txtRetencion}
                        disabled={habilitado}
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckDefault"
                        style={{ fontSize: "14px" }}
                      >
                        Fondo de Terceros
                      </label>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div className="col-md-12">
                <fieldset
                  className=" row col-sm-12 mx-auto border-azul rounded"
                  style={{ fontSizeAdjust: "0.6" }}
                >
                  <legend
                    className="float-none w-auto fw-bold"
                    style={{ fontSize: "15px" }}
                  >
                    Responsable
                  </legend>

                  <div className="input-group input-group-sm mb-2 col-pd-270 px-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CEDULA:
                    </label>
                    <select
                      ref={cmbNacionalidad}
                      name="nacionalidad"
                      className="form-select form-select-sm col-md-3"
                      disabled={habilitado}
                      aria-label=".form-select-sm example"
                      onChange={onChange}
                    >
                      <option value="V">V</option>
                      <option value="E">E</option>
                    </select>
                    <input
                      ref={txtCedRes}
                      maxLength={8}
                      autoComplete="off"
                      type="text"
                      disabled={habilitado}
                      className="form-control fs-6"
                      name="cedula"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      onKeyUp={validarPersona}
                      onBlur={validarPersona}
                      onChange={onChange}
                    />
                    <button
                      disabled={botones.catalogoper}
                      type="button"
                      onClick={() => setCatalogoPersona(true)}
                      className="btn btn-success"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>

                  <div className="input-group input-group-sm mb-2 col-pd-140 mx-auto">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      SEXO:
                    </label>
                    <select
                      ref={cmbSexo}
                      className="form-select form-select-sm"
                      name="sexo"
                      disabled={habilitadoNU}
                      onChange={onChange}
                      aria-label=".form-select-sm example"
                    >
                      <option value="">--</option>
                      <option value="M">M</option>
                      <option value="F">F</option>
                    </select>
                  </div>

                  <div className="input-group input-group-sm mb-2 col-pd-340 px-2 ml-auto">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      FECHA DE NACIMIENTO
                    </label>
                    <input
                      type="date"
                      ref={txtFechaNac}
                      max={fechaTope}
                      className="form-control text-uppercase fs-6"
                      name="fnacimiento"
                      aria-label="Sizing example input"
                      onChange={onChange}
                      disabled={habilitadoNU}
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>

                  <div className="input-group input-group-sm mb-2 col-xl-6 col-lg-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      NOMBRES:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      ref={txtNomResp}
                      name="nombres"
                      className="form-control text-uppercase fs-6"
                      onChange={onChange}
                      aria-label="Sizing example input"
                      disabled={habilitadoNU}
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-xl-6 col-lg-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      APELLIDOS:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      ref={txtApeResp}
                      name="apellidos"
                      className="form-control text-uppercase fs-6"
                      onChange={onChange}
                      aria-label="Sizing example input"
                      disabled={habilitadoNU}
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-md-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      DIRECCION:
                    </label>
                    <textarea
                      type="area"
                      autoComplete="off"
                      ref={txtDireccion}
                      name="direccion"
                      className="form-control text-uppercase fs-6"
                      onChange={onChange}
                      aria-label="Sizing example input"
                      disabled={habilitadoNU}
                      aria-describedby="inputGroup-sizing-sm"
                      style={{ height: 40 }}
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-md-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      EMAIL:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      ref={txtEmail}
                      className="form-control text-uppercase fs-6"
                      name="correoe"
                      aria-label="Sizing example input"
                      onChange={onChange}
                      disabled={habilitadoNU}
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-pd-220 px-1">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      TELEFONO:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      maxLength={12}
                      ref={txtTlf1}
                      className="form-control fs-6"
                      name="tlf1"
                      aria-label="Sizing example input"
                      onChange={onChange}
                      disabled={habilitadoNU}
                      aria-describedby="inputGroup-sizing-sm"
                      onKeyUp={handleInputNumChange}
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-pd-210 px-1">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CELULAR:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      maxLength={12}
                      ref={txtTlf2}
                      className="form-control fs-6"
                      name="tlf2"
                      aria-label="Sizing example input"
                      onChange={onChange}
                      disabled={habilitadoNU}
                      aria-describedby="inputGroup-sizing-sm"
                      onKeyUp={handleInputNumChange}
                    />
                  </div>
                </fieldset>
              </div>
              <div className="col-md-12 d-flex justify-content-between mt-2">
                {visibleBtn === "visible" ? (
                  <div className="col-md-12 col-sm-12 col-lg-12 col-12  justify-content-start">
                    <button
                      disabled={botones.incluir}
                      onClick={onBotones(1)}
                      className="btn btn-sm mx-1 btn-primary rounded-pill"
                      title="Incluir Almacen"
                    >
                      <i className="fas fa-plus">
                        {" "}
                        Incluir{" "}
                      </i>{" "}
                    </button>
                    <button
                      disabled={botones.consultar}
                      onClick={onBotones(4)}
                      className="btn btn-sm mx-1 btn-info rounded-pill"
                      title="Consultar Almacen"
                    >
                      <i className="fas fa-eye">
                        Consultar
                      </i>{" "}
                    </button>
                    <button
                      disabled={botones.modificar}
                      onClick={onBotones(2)}
                      className="btn btn-sm mx-1 btn-warning rounded-pill"
                      title="Modificar Almacen"
                    >
                      <i className="fa fa-edit">
                        Modificar
                      </i>{" "}
                    </button>
                    <button
                      disabled={botones.eliminar}
                      onClick={onBotones(3)}
                      className="btn btn-sm mx-1 btn-danger rounded-pill"
                      title="Eliminar Almacen"
                    >
                      <i className="fa fa-trash">
                        Eliminar
                      </i>{" "}
                    </button>
                  </div>
                ) : (
                  ""
                )}

                <div
                  className="col-md-12 d-flex justify-content-end"
                  style={{
                    visibility:
                      visibleBtn === "visible" ? "collapse" : "visible",
                  }}
                >
                  <button
                    disabled={botones.aceptar}
                    onClick={onBotones(5)}
                    ref={btnAcepta}
                    className="mx-2 btn btn-sm rounded-pill btn-success"
                  >
                    <i
                      className="fas fa-check-circle"
                    >
                      {" "}
                      Aceptar
                    </i>
                  </button>
                  <button
                    disabled={botones.cancelar}
                    onClick={onBotones(6)}
                    ref={btnCancela}
                    className="mx-2 btn btn-danger btn-sm rounded-pill"
                  >
                    <i
                      className="fas fa-window-close"
                    >
                      {" "}
                      Cancelar
                    </i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*  */}
      <CatalogoCliente
        show={catalogoCliente}
        nomid="beneficiario"
        onHideCancelar={() => setCatalogoCliente(false)}
        onHideAceptaCatalogo={onCatalogoCliente}
      />
      <CatalogoPersona
        show={catalogoPersona}
        onHideCancelaCatPer={() => setCatalogoPersona(false)}
        onHideAceptaCatPer={onCatalogoPersona}
      />
      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          mensaje.titulo === "Exito."
            ? blanquear()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default TablaBeneficiario;



// WEBPACK FOOTER //
// ./src/components/finanzas/tablaBeneficiarios.js